module.exports = __webpack_public_path__ + "img/horizontal_7_2_5010.2dd0ae9d.png";